import React from "react";
import { GET } from "lib/api";
import SettingStore from "stores/settings";
import LuvitComponent from "LuvitComponent";

export default class SurveyTrackingOverview extends LuvitComponent {
  constructor(props, context) {
    super(props, context, "Progress");
  }

  async componentWillMount() {
    let surveys = this.props.surveys;
    const nrOfAnswersRequired = SettingStore.getSettingValue(
      "minnbrofanswersluvitengage",
    );

    if (!surveys) {
      if (luvit.GetQueryString("courseid")) {
        surveys = await GET("v1/education/tracking/surveys/:courseId", {
          courseId: luvit.GetQueryString("courseid"),
        });
      }
    }

    this.setState({
      ready: true,
      surveys,
      nrOfAnswersRequired,
    });
  }

  doRender() {
    if (!this.state || !this.state.ready) {
      return <div> Loading... </div>;
    }
    const { nrOfAnswersRequired, surveys } = this.state;
    const { type } = this.props;

    const notEnoughAnswersText = this.l(
      "hlp_surveyAnswersActivityMinAnswers",
    ).replace("<placeholder>", nrOfAnswersRequired);
    const basePath = document.location.pathname;

    const surveyRows = surveys.map((survey) => {
      let enoughAnswers = survey.noOfAnswers >= nrOfAnswersRequired;
      return (
        <tr key={survey.surveySettingId}>
          <td> {survey.title}</td>
          <td className="center"> {survey.noOfAnswers}</td>
          {type !== "simple" && (
            <td style={{ maxWidth: "300px" }}>
              {enoughAnswers && (
                <a
                  href={
                    basePath +
                    "surveys/generatereport.aspx?surveysettingsid=" +
                    survey.surveySettingId
                  }
                >
                  {this.l("csvreport")}
                </a>
              )}
              {survey.noOfAnswers < nrOfAnswersRequired && (
                <span>{notEnoughAnswersText}</span>
              )}
            </td>
          )}
          {type !== "simple" && (
            <td>
              {enoughAnswers && (
                <a
                  href={
                    basePath +
                    "surveys/survey_report.aspx?surveysettingid=" +
                    survey.surveySettingId
                  }
                >
                  {this.l("graphicreport")}
                </a>
              )}
            </td>
          )}
        </tr>
      );
    });

    return (
      <table className="maindatatable basic morepadding">
        <thead>
          <tr>
            <th>{this.l("title")}</th>
            <th className="center">{this.l("numberofanswers")}</th>
            {type !== "simple" && <th></th>}
            {type !== "simple" && <th></th>}
          </tr>
        </thead>
        <tbody>{surveyRows}</tbody>
      </table>
    );
  }
}
